import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import { Route, Switch, Redirect } from "react-router-dom";
import NavBar from "./components/common/navBar";
import Header from "./components/common/header";
// import BreadCrumb from "./components/common/breadcrumb";
import SideNav from "./components/common/sideNav";
import Bandwidth from "./components/common/bandwidth";
import CacheServer from "./components/common/cacheServer";

import Customers from "./components/customers";
import Customer from "./components/customer";
import Leads from "./components/leads";
import Dashboard from "./components/dashboard";
import Login from "./components/login";
import NotFound from "./components/notFound";
import Footer from "./components/common/footer";
import Tariffs from "./components/tariffs";
import Routers from "./components/routers";
import RouterInfo from "./components/routerInfo";
import PonOLTs from "./components/ponOLTs";
import PonOLTInfo from "./components/ponOLTInfo";
import TariffInfo from "./components/tariffInfo";
import IpV4Pools from "./components/ipv4Pools";
import AddIpV4Pool from "./components/addIpV4Pool";
import IpV4Pool from "./components/ipV4Pool";
import Logout from "./components/logout";
import ProtectedRoute from "./components/common/protectedRoute";
import CustomerRoute from "./components/common/customerRoute";
import Unauthorized from "./components/unauthorized";
import PaymentError from "./components/paymentError";
import Transactions from "./components/transactions";
import FinancialReport from "./components/financialReport";
import DataUsage from "./components/datausage";
import MyServices from "./components/myServices";
import AllInvoices from "./components/allInvoices";
import Config from "./components/config";
import MyEquipment from "./components/myEquipment";
import Invoices from "./components/invoices";
import Expenses from "./components/expenses";
import PendingRenewals from "./components/pendingRenewals";
import Admins from "./components/admins";
import Affiliates from "./components/affiliates";
import MyAccount from "./components/myAccount";
import ChangePassword from "./components/changePassword";
import EngineerRoute from "./components/common/engineerRoute";
import AdminRoute from "./components/common/adminRoute";
import AccountsRoute from "./components/common/accountsRoute";
import SuperAdminRoute from "./components/common/superAdminRoute";
import BarChart from "./components/common/barChart";
import ResetPassword from "./components/resetPassword";
import Invoice from "./components/invoice";

import { getCurrentUser, isAdmin, isCustomer } from "./services/authService";

import "react-toastify/dist/ReactToastify.css";
import "fontsource-roboto";
import "./App.css";

class App extends Component {
  state = {};

  componentDidMount() {
    if (isAdmin) {
      //get bandwidth usage
    }
    this.setState({ currentUser: getCurrentUser() });
  }

  render() {
    const { currentUser } = this.state;
    return (
      <div className="App">
        <ToastContainer />
        {<NavBar currentUser={currentUser} />}

        <Header currentUser={currentUser} />

        {/* {currentUser && <BreadCrumb />} */}

        <section id="main">
          <div className="container-fluid container-custom">
            <div className="row">
              {currentUser && (
                <div className="col-md-3">
                  {isCustomer() && <SideNav currentUser={currentUser} />}

                  {isAdmin() && <Bandwidth />}

                  {isAdmin() && <CacheServer />}
                </div>
              )}
              <div className="col-md">
                <Switch>
                  <Route path="/chart" component={BarChart} />
                  <AdminRoute
                    path="/customers/:id"
                    render={(props) => <Customer {...props} />}
                  />
                  <EngineerRoute
                    path="/ipv4pools/:id"
                    render={(props) => <IpV4Pool {...props} />}
                  />
                  <EngineerRoute
                    path="/ncc-report"
                    render={(props) => <DataUsage {...props} />}
                  />
                  <EngineerRoute
                    path="/tariffs/:id"
                    render={(props) => <TariffInfo {...props} />}
                  />
                  <EngineerRoute
                    path="/routers/:id"
                    render={(props) => <RouterInfo {...props} />}
                  />
                  <EngineerRoute
                    path="/ponolts/:id"
                    render={(props) => <PonOLTInfo {...props} />}
                  />
                  <CustomerRoute
                    path="/invoices/:id"
                    render={(props) => <Invoices {...props} />}
                  />
                  <Route
                    path="/reset-password/:tokenId"
                    component={ResetPassword}
                  />
                  <Route path="/login" component={Login} />
                  <ProtectedRoute
                    path="/invoice/:id"
                    render={(props) => <Invoice {...props} />}
                  />
                  <Route path="/logout" component={Logout} />
                  <Route path="/reset-password" component={ResetPassword} />
                  <ProtectedRoute
                    path="/dashboard"
                    render={(props) => <Dashboard {...props} />}
                  />
                  <AdminRoute
                    path="/tariffs"
                    render={(props) => <Tariffs {...props} />}
                  />
                  <EngineerRoute
                    path="/routers"
                    render={(props) => <Routers {...props} />}
                  />
                  <ProtectedRoute
                    path="/my-account/"
                    render={(props) => <MyAccount {...props} />}
                  />
                  <ProtectedRoute
                    path="/change-password/"
                    render={(props) => <ChangePassword {...props} />}
                  />
                  <EngineerRoute
                    path="/addipv4pool/"
                    render={(props) => <AddIpV4Pool {...props} />}
                  />
                  <EngineerRoute
                    path="/ponolts"
                    render={(props) => <PonOLTs {...props} />}
                  />
                  <CustomerRoute
                    path="/my-equipment"
                    render={(props) => <MyEquipment {...props} />}
                  />
                  <CustomerRoute
                    path="/my-services"
                    render={(props) => <MyServices {...props} />}
                  />
                  <AdminRoute
                    path="/customers"
                    render={(props) => <Customers {...props} />}
                  />
                  <AdminRoute
                    path="/leads"
                    render={(props) => <Leads {...props} />}
                  />
                  <EngineerRoute
                    path="/ipv4pools"
                    render={(props) => <IpV4Pools {...props} />}
                  />
                  <SuperAdminRoute
                    path="/affiliates"
                    render={(props) => <Affiliates {...props} />}
                  />
                  <SuperAdminRoute
                    path="/admins"
                    render={(props) => <Admins {...props} />}
                  />
                  <ProtectedRoute
                    path="/transactions"
                    render={(props) => <Transactions {...props} />}
                  />
                  <SuperAdminRoute
                    path="/financial-report"
                    render={(props) => <FinancialReport {...props} />}
                  />
                  <AccountsRoute
                    path="/expenses"
                    render={(props) => <Expenses {...props} />}
                  />
                  <SuperAdminRoute
                    path="/config"
                    render={(props) => <Config {...props} />}
                  />
                  <AdminRoute
                    path="/pending-renewals"
                    render={(props) => <PendingRenewals {...props} />}
                  />
                  <AdminRoute
                    path="/all-invoices"
                    render={(props) => <AllInvoices {...props} />}
                  />
                  <CustomerRoute
                    path="/paymenterror"
                    render={(props) => <PaymentError {...props} />}
                  />
                  <ProtectedRoute
                    path="/unauthorized"
                    render={(props) => <Unauthorized {...props} />}
                  />
                  <Route path="/not-found" component={NotFound} />
                  <Route path="/" exact component={Login} />
                  <Redirect to="/not-found" />
                </Switch>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}

export default App;
